import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Action } from '@ngrx/store';

import { UploadItemAction, UploadItemActionTypes } from '@actions/uploads.actions';

import { IUploadItem, UploadStatus } from '@stylehaven/components';
import { UploadItemState } from 'state';

export const uploadItemAdapter: EntityAdapter<IUploadItem> = createEntityAdapter<IUploadItem>({
    selectId: uploadItem => uploadItem.tempId
});

export const initialState: UploadItemState = uploadItemAdapter.getInitialState();

export function uploadsReducer(state = initialState, action: Action): UploadItemState {
    const uploadItemAction: UploadItemAction = action as UploadItemAction;
    switch (uploadItemAction.type) {
        case UploadItemActionTypes.AddOrUpdate:
            return uploadItemAdapter.upsertOne(uploadItemAction.uploadItem, state);

        case UploadItemActionTypes.Add:
            return uploadItemAdapter.addOne(uploadItemAction.uploadItem, state);

        case UploadItemActionTypes.Remove:
            return uploadItemAdapter.removeOne(uploadItemAction.id, state);

        case UploadItemActionTypes.Update:
            return uploadItemAdapter.updateOne({ id: uploadItemAction.id, changes: uploadItemAction.changes }, state);

        case UploadItemActionTypes.Clear:
            return uploadItemAdapter.removeAll(state);

        default:
            return state;
    }
}

export function isUploadInProgress(uploadItem: IUploadItem): boolean {
    switch (uploadItem.state.status) {
        case UploadStatus.FINISHED:
        case UploadStatus.FAILED:
        case UploadStatus.REJECTED:
        case UploadStatus.NETWORK_ERROR:
        case UploadStatus.CANCELLED:
            return false;
        default:
            return true;
    }
}

export function isUploadFinalized(uploadItem: IUploadItem): boolean {
    return !isUploadInProgress(uploadItem);
}
